<template>
    <div id="order-klinik">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vx-card class="mb-base" title="Pemeriksaan">
            <vue-form-generator
              tag="div"
              :schema="schema"
              :model="model"
              :options="formOptions"
              @model-updated="listen"
            ></vue-form-generator>
          </vx-card>
         <vs-card class="mb-base">
           <div slot="header">
             <vs-row vs-w="12">
               <vs-col class="ml-10" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                 <h4>Nilai Normal</h4>
               </vs-col>
     					<vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-lg="7" vs-sm="8" vs-xs="12">
     	          <vs-spacer></vs-spacer>
     						<vs-tooltip text="Tambah">
     							<vs-button radius size="medium" type="border" color="#5d9fc6" icon="add" class="ml-3" @click="activePrompt=true"></vs-button>
     						</vs-tooltip>
                </vs-col>
             </vs-row>
           </div>
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2">
                <vs-table stripe :data="listNilaiNormal" noDataText="Tidak Ada Data" style="text-align:center; max-height:360px; overflow:scroll">
                    <template slot="thead">
                        <vs-th>Batas Umur Bawah</vs-th>
                        <vs-th>Batas Umur Atas</vs-th>
                        <vs-th>Jenis Kelamin</vs-th>
                        <vs-th>Alphanumeric</vs-th>
                        <vs-th>Batas Bawah</vs-th>
                        <vs-th>Batas Atas</vs-th>
                        <vs-th>&nbsp;</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{data[indextr].ageMin}}
                            </vs-td>
                            <vs-td>
                                {{data[indextr].ageMax}}
                            </vs-td>
                            <vs-td>
                                {{(data[indextr].gender.id==1?'Laki-laki':'Perempuan')}}
                            </vs-td>
                            <vs-td>
                                {{data[indextr].alphanumeric}}
                            </vs-td>
                            <vs-td>
                                {{data[indextr].rangeLower}}
                            </vs-td>
                            <vs-td>
                                {{data[indextr].rangeUpper}}
                            </vs-td>
                            <vs-td>
                                <vs-button radius style="cursor: pointer;" @click="openConfirm(indextr)" color="danger" icon="delete"></vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
              </div>
            </div>
         </vs-card>
        </div>
      </div>
      <div class="vx-col w-full" vs-justify="center">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            class="mr-4 mb-4"
            color="danger"
            @click="$router.go(-1)"
            >
            Batal
          </vs-button>
          <vs-button
            class="mr-4 mb-4"
            icon-pack="feather"
            color="#6488e4"
            @click="onConfirm"
            >
            Simpan
          </vs-button>
        </vs-row>
  		</div>

      <vs-prompt class="w50"
        title="Form Nilai Normal"
        @accept="saveNilaiNormal"
        @cancel="cancelNilaiNormal"
        accept-text="Simpan"
        cancel-text="Batal"
        :active.sync="activePrompt">
           <vx-card>
             <div class="vx-col w-full mb-2">
              <vs-row>
                <vs-col vs-w="6">
                  <vs-input name="ageMin" label="Batas Umur Bawah" class="w-5/6" v-model="ageMin"/>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-input name="ageMax" label="Batas Umur Atas" class="w-5/6" v-model="ageMax"/>
                </vs-col>
              </vs-row>
              <vs-row class="mt-2">
                <vs-col vs-w="6">
                    <vs-select
                      label="Jenis Kelamin"
                      v-model="gender"
                      class="w-5/6"
                      >
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in [{value: 1, text: 'Laki-laki'}, {value: 2, text: 'Perempuan'}]" />
                    </vs-select>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-input name="alphanumeric" label="Alphanumeric" class="w-5/6" v-model="alphanumeric"/>
                </vs-col>
              </vs-row>
              <vs-row class="mt-2">
                <vs-col vs-w="6">
                  <vs-input name="rangeLower" label="Batas Nilai Bawah" class="w-5/6" v-model="rangeLower"/>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-input name="rangeUpper" label="Batas Nilai Atas" class="w-5/6" v-model="rangeUpper"/>
                </vs-col>
              </vs-row>
             </div>
           </vx-card>
       </vs-prompt>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import lab from "@/api/lab";
import master from "@/api/master";
import form from "@/api/form";
import tool from "@/tool/form_tool";
import moment from 'moment';

export default {
  components: {
      Datepicker
  },
  data() {
    return {
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
      },
      listNilaiNormal: [],
      listTest: [],
      loading: false,
      test: null,
      idxSelected: null,
      activePrompt: false,
      ageMin: 0,
      ageMax: 0,
      rangeLower: 0,
      rangeUpper: 0,
      gender: 1,
      alphanumeric: ''
    };
  },
  methods: {
		listen(newVal, schema) {
		},
    openConfirm(id) {
        this.idxSelected = id;
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert
        });
    },
    acceptAlert() {
      this.listNilaiNormal.splice(this.idxSelected, 1);
    },
    saveNilaiNormal() {
      let x = {}
      x.ageMin = this.ageMin;
      x.ageMax = this.ageMax;
      x.alphanumeric = this.alphanumeric;
      x.rangeLower = this.rangeLower;
      x.rangeUpper = this.rangeUpper;
      console.log(this.gender);
      x.gender = {id: this.gender, name: (this.gender.id==1?'Laki-laki':'Perempuan')}
      //x.measureType = {id: }
      this.listNilaiNormal.push(x)

      this.cancelNilaiNormal();
    },
    cancelNilaiNormal() {
      this.ageMin= 0;
      this.ageMax= 0;
      this.rangeLower= 0;
      this.rangeUpper= 0;
      this.gender= 1;
      this.alphanumeric= '';
    },
    onConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin untuk menyimpan data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
    },
    saveData() {
      this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
      };

      let md = this.model;
      let ms = [];
      for (let i = 0; i < this.listNilaiNormal.length; i++) {
        let lp = this.listNilaiNormal[i];
        let me = { id: lp.id, ageMin: lp.ageMin,
                    ageMax: lp.ageMax, gender: {id : lp.gender.id},
                    alphanumeric : lp.alphanumeric, rangeLower:lp.rangeLower,
                    rangeUpper:lp.rangeUpper};
        ms.push(me);
      }
      md.measureRanges = ms;
      if (isNaN(parseInt(md.secret))) {
        if (md.secret) {
          md.secret = 1;
        } else {
          md.secret = 0;
        }
      }

			lab.saveMeasure(md, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/pemeriksaan/measure/list"
						);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
        console.log('error :'+error);
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});

		},
    async getTube() {
      const prov = await master.getTube();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"tube",
				prov.data.data
			);
    },
    async getMeasureType() {
      const prov = await master.getMeasureType();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"measureType",
				prov.data.data
			);
    },
    async getChoiceGroup() {
      const prov = await master.getChoiceGroup();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"choiceGroup",
				prov.data.data
			);
    },
		async firstLoad() {
			const frm = await form.measure();
			this.schema.fields = frm.data.data[0].fields;
			let idx = this.$route.params.id;
			if (idx) {
				const xmodel = await lab.getMeasure(idx);
        this.model = xmodel.data.data[0];
        this.listNilaiNormal = this.model.measureRanges;
			} else {
				this.model = frm.data.data[0].model;
      }
      await this.getTube();
      await this.getMeasureType();
      await this.getChoiceGroup();
    },
    clear() {

    },
    searchTest() {

    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.firstLoad();
  }
};
</script>
